module.exports = __webpack_public_path__ + "img/king-cake.273ffc93.svg";